/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import {
  Dashboard,
  AttachMoney as AttachMoneyIcon,
  TrendingUp as TrendingUpIcon,
  LooksOne as LooksOneIcon,
  Twitter as TwitterIcon,
  ShoppingCart as CoupangIcon,
  ChildCare as ChildCareIcon,
} from '@material-ui/icons';
// core components/views for Admin layout

import DashboardPage from 'views/Dashboard/Dashboard';
import FXIPage from 'views/Fxi/Fxi';
import StockPage from 'views/Stock/Stock';
import LottoPage from 'views/Lotto/Lotto';
import TwitterPage from 'views/Twitter/Twitter';
import CoupangPage from 'views/Coupang/Coupang';

const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: Dashboard,
    component: DashboardPage,
    layout: ''
  },
  {
    path: '/fxi',
    name: '환율 계산기',
    icon: AttachMoneyIcon,
    component: FXIPage,
    layout: ''
  },
  {
    path: '/stock',
    name: '주식',
    icon: TrendingUpIcon,
    component: StockPage,
    layout: ''
  },
  {
    path: '/lotto',
    name: '로또',
    icon: LooksOneIcon,
    component: LottoPage,
    layout: ''
  },
  {
    path: '/coupang',
    name: '쿠팡 바로가기',
    icon: CoupangIcon,
    component: CoupangPage,
    layout: ''
  },
  {
    path: '/twitter',
    name: '트위터 영상',
    icon: TwitterIcon,
    component: TwitterPage,
    layout: '',
    state: 'dev'
  },
  // {
  //   path: '/donate',
  //   name: '개발자 도와주기 😆',
  //   icon: ChildCareIcon,
  //   component: TwitterPage,
  //   layout: '',
  //   state: 'dev'
  // },
];

export default dashboardRoutes;
